import Typography from "mobily-ui-library/lib/components/primitive/Typography/Typography";
import { useTranslation } from "react-i18next";

export interface Props {
    rtl: boolean;
    OrderDetailsProduct:any;
}

function OrderCard({ rtl, OrderDetailsProduct }: Props) {
    const dir = rtl ? "right" : "left";
    const { t } = useTranslation();
    const SimLines= OrderDetailsProduct?.productInformation?.quantity.value > 1 ? `${t('Lines')} ${OrderDetailsProduct?.productInformation?.quantity.value} ` : `${t('Line')} ${OrderDetailsProduct?.productInformation.quantity.value} `;

    const priceWithoutVat = OrderDetailsProduct?.productInformation.quantity.value * OrderDetailsProduct.productInformation.packageName.price;
    const vatPrice = priceWithoutVat * 0.15;
    const totalAmountWithVat = priceWithoutVat + vatPrice;

    return (
        <div className={`orders-card`}>
            <Typography className='orders-card-title sansFont' rtl={rtl}>{OrderDetailsProduct.productInformation.packageName.value}</Typography>
            <div className='orders-lists'>
                <div className={`row orderRow-${dir}`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? t('Number_of_lines') : SimLines  }</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? SimLines : t('Number_of_lines')}</Typography>
                </div>
                <div className={`row orderRow-${dir}`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? t('SIM_Type') : OrderDetailsProduct.productInformation.simType.text}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? OrderDetailsProduct.productInformation.simType.text : t('SIM_Type')}</Typography>
                </div>
                <div className={`row orderRow-${dir}`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? `${t('PriceWithoutVat')}` : `${priceWithoutVat} ${t('SAR')}`}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? `${priceWithoutVat} ${t('SAR')}` : `${t('PriceWithoutVat')}`}</Typography>
                </div>

                <div className={`row orderRow-${dir}`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? `${t('VAT')}` : `${vatPrice} ${t('SAR')}`}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? `${vatPrice} ${t('SAR')}` : `${t('VAT')}`}</Typography>
                </div>

                <div className={`row orderRow-${dir}`}>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? `${t('TotalAmount')}` : `${totalAmountWithVat} ${t('SAR')}`}</Typography>
                    <Typography className='col-sm-6 sansFont list-text' rtl={rtl}>{!rtl ? `${totalAmountWithVat} ${t('SAR')}` : `${t('TotalAmount')}`}</Typography>
                </div>
            </div>
        </div>
    )
}

export default OrderCard